import { render } from "./account-setup.vue?vue&type=template&id=e6af39f4&scoped=true"
import script from "./account-setup.vue?vue&type=script&lang=js"
export * from "./account-setup.vue?vue&type=script&lang=js"

import "./account-setup.vue?vue&type=style&index=0&id=e6af39f4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6af39f4"]])

export default __exports__